<template>
  <div class="mb-2 box-shaddow col card-pointer order-card bg-white">
    <div class="order-card__time-wrapper">
      <template v-if="type === 'pending'">
        <div class="order-card__time">
          {{ startTime(bookingStartTime) }}
        </div>
        <div class="order-card__duration">
          {{ duration }}
        </div>
      </template>
      <template v-if="type === 'que'">
        <div class="order-card__time">
          {{ startTime(startedAt) }}
        </div>
        <div class="order-card__duration">
          {{ duration }}
        </div>
      </template>
      <template v-if="type === 'inWork'">
        {{ startTime(realDate) }}
      </template>
      <template v-if="type === 'isEnd'">
        <div class="order-card__time">
          {{ startTime(finishedAt) }}
        </div>
      </template>
    </div>
    <div class="order-card__car">
      <v-img
        v-if="showIcon"
        :src="carLogoSrc"
        class="order-card__icon"
        width="60"
        height="60"
        contain
      />
      <div class="order-card__car-name">
        {{ carName }}
      </div>
    </div>
    <div class="order-card__icons">
      <template v-if="showIcon">
        <v-img v-if="hasLongTimeServices" class="order-card__icon">
          <v-icon color="red">
            mdi-clock-outline
          </v-icon>
        </v-img>
        <!-- <v-img
          v-for="(icon, index) in iconConfig"
          :key="index"
          :src="require(`@/assets/images/order-card/${icon.nameFile}`)"
          class="order-card__icon"
          width="30"
          height="30"
          contain
        /> -->
      </template>
    </div>
    <div class="order-card__discount">
      <template v-if="discount"> {{ discount }}% </template>
      <template v-if="price">
        <b> {{ price }}₽</b>
      </template>
    </div>
    <div class="order-card__name">
      {{ customerName }}
    </div>

    <div
      class="order-card__deliver"
      v-if="storageAgreement && storageAgreement.contract_number"
    >
      <span v-if="delivered">
        <v-tooltip bottom>
          <template v-slot:activator="{ on }">
            <v-icon v-on="on" color="green darken-2">
              mdi-store-outline
            </v-icon>
          </template>
          <span>Доставлено</span>
        </v-tooltip>
        {{ storageAgreement.contract_number }}
      </span>
      <span v-else>
        <v-tooltip bottom>
          <template v-slot:activator="{ on }">
            <v-icon
              v-on="on"
              color="blue darken-2"
              @click.stop="
                showDelInfo([
                  id,
                  storageAgreement.contract_number,
                  phone,
                  index,
                ])
              "
            >
              mdi-truck-delivery-outline
            </v-icon>
          </template>
          <span>Ожидает доставки</span>
        </v-tooltip>
        {{ storageAgreement.contract_number }}
      </span>
    </div>

    <div
      class="time-text d-flex order-card__timer"
      v-if="type === 'inWork' || type === 'isEnd'"
      :class="
        timeToEndFact - timeToEndPlan > 0
          ? 'red--text text--lighten-1'
          : 'green-text text--lighten-1'
      "
      v-html="msToHMS(timeToEndFact)"
    />
  </div>
</template>

<script>
import { mapActions } from 'vuex';
export default {
  name: "OrderCard",
  data() {
    return {
      showIcon: true,
      carLogoSrc: 'data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iNjAiIGhlaWdodD0iNjAiIHZpZXdCb3g9IjAgMCA2MCA2MCIgZmlsbD0ibm9uZSIgeG1sbnM9Imh0dHA6Ly93d3cudzMub3JnLzIwMDAvc3ZnIj48cmVjdCB3aWR0aD0iNjAiIGhlaWdodD0iNjAiIGZpbGw9Im5vbmUiLz48L3N2Zz4=', // transparent SVG base64
      iconConfig: [
        {
          nameFile: "9 filters B-01.png",
        },
        {
          nameFile: "9 filters B-03.png",
        },
        {
          nameFile: "9 filters B-05.png",
        },
        {
          nameFile: "9 filters B-06.png",
        },
        {
          nameFile: "9 filters B-07.png",
        },
      ],
    };
  },
  props: {
    shouldBeFinishedAt: {},
    price: {},
    startedAt: {},
    finishedAt: {},
    carName: {},
    customerName: {},
    duration: {},
    discount: {},
    phone: {},
    contractNumber: {},
    delivered: {},
    id: {},
    storageAgreement: {},
    realDate: {},
    index: {},
    bookingStartTime: {},
    params: {},
    hasLongTimeServices: {},
    type: {
      type: String,
      default: "que",
      validator(value) {
        return ["pending", "que", "inWork", "isEnd"].includes(value);
      },
    },
  },
  watch: {
    params: {
      immediate: true,
      handler(newParams) {
        this.loadCarLogo(newParams && newParams.carId);
      }
    }
  },
  methods: {
    ...mapActions('shift', ['fetchCarLogo']),
    msToHMS(ms) {
      // 1- Convert to seconds:
      let seconds = ms / 1000;
      // 2- Extract hours:
      let hours = parseInt(seconds / 3600); // 3,600 seconds in 1 hour
      seconds = seconds % 3600; // seconds remaining after extracting hours
      // 3- Extract minutes:
      let minutes = parseInt(seconds / 60); // 60 seconds in 1 minute
      // 4- Keep only seconds not extracted to minutes:
      seconds = parseInt(seconds % 60);
      if (hours) {
        if (hours <= 9) {
          hours = "0" + hours;
        }
        if (minutes <= 9) {
          minutes = "0" + minutes;
        }
        if (seconds <= 9) {
          seconds = "0" + seconds;
        }
        return (
          '<div class="hh-text">' +
          hours +
          '</div>:<div class="mm-text">' +
          minutes +
          "</div>"
        );
      } else if (minutes) {
        if (minutes <= 9) {
          minutes = "0" + minutes;
        }
        if (seconds <= 9) {
          seconds = "0" + seconds;
        }
        return (
          '<div class="mm-text">' +
          minutes +
          '</div> <div class="ss-text">' +
          seconds +
          "</div>"
        );
      } else {
        if (seconds <= 9) {
          seconds = "0" + seconds;
        }
        return '<div class="ss-text">' + seconds + "</div>";
      }
    },
    showDelInfo(info) {
      this.$emit("showDelInfo", info);
    },
    startTime(date) {
      const tdate = new Date(date);
      let h = tdate.getHours();
      h = h < 10 ? "0" + h.toString() : h.toString();
      let m = tdate.getMinutes();
      m = m < 10 ? "0" + m.toString() : m.toString();
      return h + ":" + m;
    },
    async loadCarLogo(carId) {
      console.log('Trying to load car logo for carId:', carId);
      if (!carId) {
        this.carLogoSrc = 'data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iNjAiIGhlaWdodD0iNjAiIHZpZXdCb3g9IjAgMCA2MCA2MCIgZmlsbD0ibm9uZSIgeG1sbnM9Imh0dHA6Ly93d3cudzMub3JnLzIwMDAvc3ZnIj48cmVjdCB3aWR0aD0iNjAiIGhlaWdodD0iNjAiIGZpbGw9Im5vbmUiLz48L3N2Zz4=';
        return;
      }
      try {
        const result = await this.fetchCarLogo({ carId });
        if (result && result.icon) {
          this.carLogoSrc = `data:image/svg+xml;base64,${result.icon}`;
        } else {
          this.carLogoSrc = 'data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iNjAiIGhlaWdodD0iNjAiIHZpZXdCb3g9IjAgMCA2MCA2MCIgZmlsbD0ibm9uZSIgeG1sbnM9Imh0dHA6Ly93d3cudzMub3JnLzIwMDAvc3ZnIj48cmVjdCB3aWR0aD0iNjAiIGhlaWdodD0iNjAiIGZpbGw9Im5vbmUiLz48L3N2Zz4=';
        }
      } catch (e) {
        this.carLogoSrc = 'data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iNjAiIGhlaWdodD0iNjAiIHZpZXdCb3g9IjAgMCA2MCA2MCIgZmlsbD0ibm9uZSIgeG1sbnM9Imh0dHA6Ly93d3cudzMub3JnLzIwMDAvc3ZnIj48cmVjdCB3aWR0aD0iNjAiIGhlaWdodD0iNjAiIGZpbGw9Im5vbmUiLz48L3N2Zz4=';
      }
    },
  },
  computed: {
    timeToEndFact() {
      let time;
      if (this.finishedAt) {
        time = new Date(this.finishedAt) - new Date(this.startedAt);
      } else {
        time = this.realDate - new Date(this.startedAt);
      }
      return time;
    },
    timeToEndPlan() {
      const time = new Date(this.shouldBeFinishedAt) - new Date(this.startedAt);
      return time;
    },
  },
};
</script>

<style lang="scss" scoped>
//.time {
//  grid-area: 1 / 1 / 2 / 2;
//}
//.car {
//  grid-area: 1 / 2 / 2 / 4;
//}
//.price {
//  grid-area: 1 / 4 / 2 / 5;
//}
//.blank-left-down {
//  grid-area: 2 / 1 / 4 / 2;
//}
//.icons {
//  grid-area: 2 / 2 / 3 / 4;
//}
//.name {
//  grid-area: 3 / 2 / 4 / 4;
//}
//.blank-right-top {
//  grid-area: 2 / 4 / 3 / 5;
//}
//.delivery {
//  grid-area: 3 / 4 / 4 / 5;
//}
.order-card {
  display: grid;
  grid-template-columns: repeat(4, 1fr);
  grid-template-rows: repeat(3, auto);
  grid-column-gap: 10px;
  grid-row-gap: 10px;
  padding: 10px;
  font-size: 18px;
  min-height: 110px;
  @media (max-width: 1440px) {
    grid-template-columns: repeat(4, 1fr);
  }
  &__timer {
    grid-area: 2 / 1 / 4 / 2;
    align-items: flex-end;
  }
  &__time-wrapper {
    grid-area: 1 / 1 / 2 / 2;
    @media (max-width: 1440px) {
      grid-area: 2 / 1 / 3 / 3;
    }
  }
  &__icons {
    grid-area: 2 / 2 / 3 / 4;
    display: flex;
    align-items: center;
    justify-content: center;
    gap: 5px;
    padding: 5px;
  }
  &__deliver {
    grid-area: 3 / 4 / 4 / 5;
  }
  &__car {
    grid-area: 1 / 2 / 2 / 4;
    text-align: center;
    display: flex;
    align-items: center;
    @media (max-width: 1440px) {
      grid-area: 1 / 1 / 2 / 5;
    }
  }
  &__discount {
    grid-area: 1 / 4 / 2 / 5;
    text-align: right;
    @media (max-width: 1440px) {
      grid-area: 2 / 3 / 3 / 5;
    }
  }
  &__name {
    overflow: hidden;
    text-align: center;
    grid-area: 3 / 2 / 4 / 4;
    align-self: flex-end;
    @media (max-width: 1440px) {
      grid-area: 3 / 1 / 4 / 5;
    }
  }
}

/*.div1 { grid-area: 1 / 1 / 2 / 2; }*/
/*.div2 { grid-area: 1 / 4 / 2 / 5; }*/
/*.div3 { grid-area: 2 / 4 / 3 / 5; }*/
/*.div4 { grid-area: 2 / 1 / 3 / 2; }*/
/*.div5 { grid-area: 1 / 2 / 2 / 4; }*/
/*.div6 { grid-area: 2 / 2 / 3 / 4; }*/
</style>
